import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "usbChargingPort"
const UsbChargingPortIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="m18.67 7.13-.53.531-.53-.53.53-.53zM17.345 5.806l-.53.53-.531-.53.53-.53z" />
          <path
            fillRule="evenodd"
            d="m22.25 6.867-3.537 3.538a1.5 1.5 0 0 1-.195 1.883l-2.76 2.76a4.88 4.88 0 0 1-5.978.72l-.016.005-.131.043a3.6 3.6 0 0 0-.72.36c-.544.355-1.156.965-1.439 2.017-.304 1.138-.211 1.938-.07 2.425.07.247.155.422.216.529q.047.078.068.107l.052.066a.751.751 0 0 1-1.182.922l-.02-.023-.013-.017-.053-.071a3 3 0 0 1-.152-.237 4 4 0 0 1-.36-.86c-.216-.755-.309-1.832.065-3.228.397-1.482 1.285-2.373 2.07-2.885q.223-.143.43-.25a4.877 4.877 0 0 1 .34-6.517l2.759-2.76a1.5 1.5 0 0 1 1.76-.266l3.563-3.564zm-7.746-.715 3.164 3.168 2.46-2.453-3.18-3.181z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UsbChargingPortIcon
